export default __webpack_public_path__ + "static/media/jasmy.33583e10.png";